import { render } from "./FrameJavaEditor.vue?vue&type=template&id=cc90a928&scoped=true"
import script from "./FrameJavaEditor.vue?vue&type=script&lang=js"
export * from "./FrameJavaEditor.vue?vue&type=script&lang=js"

import "./FrameJavaEditor.vue?vue&type=style&index=0&id=cc90a928&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc90a928"]])

export default __exports__